<template>
  <span class="bc-dropdown">
    <button
      type="button"
      class="bc-dropdown__trigger"
      :class="{ 'bc-dropdown__trigger--current': current }"
      @click="toggle"
    >
      {{ label }}
      <i :class="['pi', open ? 'pi-chevron-up' : 'pi-chevron-down', 'bc-dropdown__caret']" aria-hidden="true" />
    </button>
    <Menu ref="menuRef" :model="model" popup @hide="open = false" @show="open = true" />
  </span>
</template>

<script setup>
import { computed, ref } from 'vue'
import Menu from 'primevue/menu'

// A breadcrumb crumb that opens a PrimeVue Menu of sibling options. Each option
// is `{ label, active, onClick }`; the active row shows a check. PrimeVue Menu
// handles outside-click / on-select close.
const props = defineProps({
  label: { type: String, required: true },
  options: { type: Array, default: () => [] },
  current: { type: Boolean, default: false },
})

const menuRef = ref(null)
const open = ref(false)

const model = computed(() =>
  props.options.map((opt) => ({
    label: opt.label,
    icon: opt.active ? 'pi pi-check' : undefined,
    class: opt.active ? 'bc-dropdown__item--active' : undefined,
    command: () => opt.onClick?.(),
  })),
)

function toggle(event) {
  menuRef.value?.toggle(event)
}
</script>

<style scoped>
.bc-dropdown {
  position: relative;
  display: inline-flex;
}

.bc-dropdown__trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 5px;
  font-weight: 500;
  color: var(--p-surface-400);
}

.bc-dropdown__trigger:hover {
  background: var(--p-overlay-popover-background);
  color: var(--p-text-muted-color);
}

.bc-dropdown__trigger--current {
  font-weight: 700;
  color: var(--p-text-muted-color);
}

.bc-dropdown__caret {
  font-size: 8px;
  opacity: 0.6;
}
</style>
